import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class YardAdministrationService {

  constructor(private appServerAPI: AppServerAPI) { }

  public triggerYardClientsReload(): Observable<ServiceResponse> {
    return this.appServerAPI.execute('/client/admin/yard/trigger-client-reload', {}).pipe(map(r => new ServiceResponse(r)));
  }

  public cleanTransports(): Observable<ServiceResponse> {
    return this.appServerAPI.execute('/client/admin/yard/clean-transports', {}).pipe(map(r => new ServiceResponse(r)));
  }

  public emergencyCall(language: string) {
    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'emergency');

    // keep focus in current window
    window.focus();

    const url = `/client/admin/yard/create-ermergency-printout`;
    this.appServerAPI.postWithArraybufferResponse<any>(url, language).subscribe(result => {

      const file = new Blob([result], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }

  public exportConfiguration(yardkey: string) {
    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'configuration');

    // keep focus in current window
    window.focus();

    const url = `/client/admin/yard/export-configuration`;
    this.appServerAPI.postWithArraybufferResponse<any>(url, yardkey).subscribe(result => {

      const file = new Blob([result], { type: 'application/xml' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

      // this provokes a download dialog, does not work with firefox.
      //this.fakeDownloadLink(fileURL);

    }, error => {
      console.error(error);
    });
  }

}
